export default function AttorneyBar() {
  return (
    <div
      data-testid="attorney-id-bar"
      className="relative bg-paper border-y border-ink/10"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-12 lg:px-20 py-3 md:py-4">
        <p className="font-body text-[12px] md:text-[13px] leading-snug text-gray-700 text-center md:text-left">
          <span className="font-medium text-ink">Binoye Jos, Esq.</span>
          <span className="mx-2 text-gray-400" aria-hidden>·</span>
          <span>Jos Family Law</span>
          <span className="mx-2 text-gray-400" aria-hidden>·</span>
          <span>1918 W. Chapman Ave, Suite 200, Orange, CA 92868</span>
          <span className="mx-2 text-gray-400" aria-hidden>·</span>
          <a
            href="tel:+17147337066"
            data-testid="attorney-bar-phone"
            className="text-teal hover:text-ink transition-colors font-medium whitespace-nowrap"
          >
            (714) 733-7066
          </a>
        </p>
      </div>
    </div>
  );
}
